import { api } from '@/api/client'
import { useAsync } from '@/components/useAsync'
import type { Role } from '@/lib/types'
import { ReviewFeedback } from './ReviewFeedback'
import type { ReviewDetail } from './types'

/** Keep the closed QC feedback beside the work it asks the expert to revise. */
export function ReturnedQualityFeedback({ taskId, roundId, role }: {
  taskId: string; roundId: string; role: Role
}) {
  const base = `/tasks/${taskId}/reviews/${roundId}`
  const { data, error, reload } = useAsync(() => api.get<ReviewDetail>(base), [base])
  if (error) return <div className="note err" role="alert">
    Could not load quality-check feedback. <button className="link" onClick={reload}>Retry</button>
  </div>
  if (!data) return <p className="muted" role="status">Loading quality-check feedback…</p>
  return <ReviewFeedback data={data} role={role} title="Quality-check feedback"
    open={false} busy={false} base={base} action={async () => false} />
}
